import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import PageBody from 'components/atoms/PageBody'
import PageHeading from 'components/atoms/PageHeading'
import TimetableForm from 'components/organisms/forms/TimetableForm'

import { crudActionsMap } from 'utils/helpers'

const TimetableCrudPage = () => {
  const { t } = useTranslation()
  const params = useParams()
  const id = params?.id

  const action = crudActionsMap[params['*']?.split('/')?.[1]]
  const viewOnly = action === 'view' || action === 'delete'

  return (
    <>
      <PageHeading title={`${t('common.group-schedule')} / ${t('common.' + action)}`} />
      <PageBody>
        <TimetableForm action={action} id={id} viewOnly={viewOnly} />
      </PageBody>
    </>
  )
}
export default TimetableCrudPage
